'use client'

import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { useState } from 'react'
import { ProductForPageFragment } from '@productsite-beta/src/graphql/generated/graphql-types'

import ProductCardVariantCombination from '@dustin-web/product-components/src/cards/product-card-variant-combination'
import ExpandButton from '@dustin-web/microsite-components/src/expand-button'

export default function OtherCombinationCards({ product }: { product: ProductForPageFragment }) {
  const { translate } = useTranslations()
  const [showAll, setShowAll] = useState(false)

  if (!product.variants) {
    return null
  }

  const toggleShowAll = () => {
    setShowAll(prevState => !prevState)
  }

  const variantsToDisplay = showAll
    ? product.variants.productsWithoutVariantCombination
    : product.variants.productsWithoutVariantCombination.slice(0, 4)

  return (
    <>
      <div className="u-relative">
        <div>
          {variantsToDisplay.map((v, key) => (
            <ProductCardVariantCombination
              product={v}
              key={key}
              ticket="variantCombinations"
              digitalDataOrigin="productPageVariant"
              digitalIndex={key}
            />
          ))}
        </div>
        {!showAll && product.variants.productsWithoutVariantCombination.length > 4 && (
          <div className="u-absolute variant-gradient"></div>
        )}
      </div>

      {product.variants.productsWithoutVariantCombination.length > 4 && (
        <div className="d-flex justify-content-center u-pb-8">
          <ExpandButton
            onClick={toggleShowAll}
            collapsedTitle={translate('ShowMore')}
            expandedTitle={translate('ShowLess')}
            expanded={showAll}
            ariaControls="expandable-variant-cards"
          />
        </div>
      )}
    </>
  )
}
